import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { PageComponent } from './page/page.component';
import { BannerComponent } from './sections/banner/banner.component';
import { FormsModule } from '@angular/forms';
import { CardPaymentsComponent } from './sections/card-payments/card-payments.component';
import { PaymentSliderComponent } from './sections/payment-slider/payment-slider.component';
import { PlatformsComponent } from './sections/platforms/platforms.component';
import { PaymentMethodsComponent } from './sections/payment-methods/payment-methods.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TailoredSolutionComponent } from './sections/tailored-solution/tailored-solution.component';


const routes:Route[] =[
  { path :"", component:PageComponent },
]
@NgModule({
  declarations: [
    PageComponent,
    BannerComponent,
    CardPaymentsComponent,
    PaymentSliderComponent,
    PlatformsComponent,
    PaymentMethodsComponent,
    TailoredSolutionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    SlickCarouselModule
  ]
})
export class PaymentGatewayModule { }
